import { useEffect, useState } from "react";
import { fetchCategoryCounts } from "@/lib/api";

// Actual products/services located in or serving the selected PIN (same visibility rules as browsing). null = unavailable.
export function usePinCounts(pincode, radiusKm) {
  const [c, setC] = useState(null);
  useEffect(() => {
    if (!pincode) { setC(null); return undefined; }
    let alive = true;
    setC(null);
    fetchCategoryCounts({ pincode, radius_km: radiusKm || undefined })
      .then((r) => alive && setC(r?.in_pin || null))
      .catch(() => alive && setC(null));
    return () => { alive = false; };
  }, [pincode, radiusKm]);
  return c;
}
